// Reseller commission (laravel App\Commission): the reseller's Commission page and the super admin's Reseller
// commission section on the Billing page. The server checks everything again; these only explain early.

// Why this is not a usable Paystack payment link, or '' (as the server: https, on paystack.com or paystack.shop)
export function paystackProblem(url) {
	const value = (url || '').trim();
	if (value === '') {
		return 'Please enter your Paystack payment link.';
	}
	if (value.length > 500) {
		return 'The Paystack payment link is too long.';
	}
	let parsed;
	try {
		parsed = new URL(value);
	} catch (e) {
		return 'The Paystack payment link must start with https://';
	}
	if (parsed.protocol !== 'https:' || parsed.username || parsed.password) {
		return 'The Paystack payment link must start with https://';
	}
	const host = parsed.hostname.toLowerCase();
	const paystack = ['paystack.com', 'paystack.shop'].some((domain) => host === domain || host.endsWith('.' + domain));
	return paystack ? '' : 'This is not a Paystack link. It should look like https://paystack.com/pay/your-page';
}

// Why Submit invoice cannot be pressed now, or ''
export function submitProblem(page, savedLink) {
	if (!page || Number(page.owed_now_usd) <= 0) {
		return 'There is no commission to invoice yet.';
	}
	if (!savedLink || paystackProblem(savedLink)) {
		return 'Please enter and save your Paystack payment link first.';
	}
	return '';
}

// Why Mark paid cannot be sent, or '': the date it was paid (YYYY-MM-DD, not after $today) and the Paystack reference
export function markPaidProblem(paidOn, reference, today) {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(paidOn || '')) {
		return 'Please give the date it was paid.';
	}
	if (today && paidOn > today) {
		return 'The date it was paid cannot be in the future.';
	}
	if (!(reference || '').trim()) {
		return 'Please give the Paystack reference of the payment.';
	}
	return '';
}

// A commission invoice's status for the tables: "Paid 3 Nov 2026 (FreeAgent)" or "Awaiting payment"
export function commissionStatus(invoice, shortDate) {
	if (!invoice || invoice.status !== 'paid') {
		return { label: 'Awaiting payment', tone: 'warning' };
	}
	const how = invoice.paid_by === 'freeagent' ? ' (from FreeAgent)' : '';
	return { label: 'Paid ' + (shortDate ? shortDate(invoice.paid_on) : invoice.paid_on) + how, tone: 'success' };
}

// Today in the browser as YYYY-MM-DD (the Mark paid dialog's default date)
export function todayIso(now) {
	const date = now || new Date();
	const pad = (n) => (n < 10 ? '0' : '') + n;
	return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
}
